export default __webpack_public_path__ + "static/media/CimmerianCamp.f6ffefdc.jpg";